import { gql } from '@apollo/client';

export const PageReplyFragment = gql`
    fragment PageReply on PageReply {
        page
        size
        total
    }
`;
